import React, { useEffect } from "react";
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import Alert from 'react-bootstrap/Alert'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CardGroup from 'react-bootstrap/CardGroup'
import Carousel from 'react-bootstrap/Carousel'
import Modal from 'react-bootstrap/Modal'
import Dropdown from "react-bootstrap/Dropdown";
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Table from 'react-bootstrap/Table'
import DropdownButton from "react-bootstrap/DropdownButton";
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FiEdit, FiCopy, FiInfo, FiInstagram } from 'react-icons/fi'
import { FaBirthdayCake } from "react-icons/fa";
import { GiPodiumWinner } from 'react-icons/gi'
import { FaUsers } from 'react-icons/fa';
import { GoPrimitiveDot } from "react-icons/go";
import { AiOutlineBug, AiOutlineLock } from "react-icons/ai";
import { RxEnter } from 'react-icons/rx'
import { GetLeagueByName, GetLeaguesByIds, GetNextEvent, GetEvents, GetResults, GetDisabled, DisableEditing, AddUserToLeague, GetRiders, GetTeam } from "../../../ApiRampageRequests";
import { GetUser } from '../../../ApiRequests'
import { Helmet } from 'react-helmet'
import { FaFlagCheckered, FaCircle } from 'react-icons/fa';
import { RiArrowGoBackFill } from "react-icons/ri";
import { BiWorld } from "react-icons/bi";
import Flag from 'react-world-flags';
import getCountryISO2 from 'country-iso-3-to-2';
import Banner_Ad_Mobile from '../../../Images/DMR/Banner_Ad_Mobile.jpg'
import Banner_Ad_NonMobile from '../../../Images/DMR/Banner_Ad_NonMobile.jpg'
import Tower_Ad_Left from '../../../Images/DMR/Tower_Ad_Left.jpg'
import Tower_Ad_Right from '../../../Images/DMR/Tower_Ad_Right.jpg'

import './index.css'
import '../../main.css'


const RampageDashboard = (props) => {

    const URL = process.env.REACT_APP_FRONT_END_URL

    const navigate = useNavigate()
    const [leagues, setLeagues] = useState([])
    const [userTeams, setUserTeams] = useState([])
    const [userTeam, setUserTeam] = useState('')
    const [user, setUser] = useState({})
    const [nextEvent, setNextEvent] = useState({})
    const targetDate = new Date(nextEvent?.date); // Thursday, June 8th, 5pm CEST
    const [timeRemaining, setTimeRemaining] = useState('');

    const [showResults, setShowResults] = useState(false)
    const [results, setResults] = useState([])
    const [filteredResults, setFilteredResults] = useState([])
    const [genderFilter, setGenderFilter] = useState('Male')
    const [pointsFilter, setPointsFilter] = useState('Overall')
    const [event, setEvent] = useState({})
    const [editingDisabled, setEditingDisabled] = useState(true)
    const [events, setEvents] = useState([])
    const [overallStandings, setOverallStandings] = useState([])

    const [overallFilteredResults, setOverallFilteredResults] = useState([])
    const [overallGenderFilter, setOverallGenderFilter] = useState('Male')
    const [team, setTeam] = useState([])

    const GLOBAL_LEAGUEID = '6504ab5ed4cb5b56c139b861'

    const getGlobalLeague = async () => {
        const league = await GetLeagueByName('Global')
        if (!league) { return }
    }

    const getUser = async () => {
        const userId = localStorage.getItem('userID')
        const _user = await GetUser(userId)
        if (!_user) { return }
        if (!'data' in _user) { return }

        setUser(_user.data)
        return _user
    }

    const getEditingDisabled = async () => {
        const res = await GetDisabled()
        if (!res || !res.data) {
            console.log("NO DATA")
            return
        }

        setEditingDisabled(res.data.disabled)
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();

        return `${year}-${month}-${day}`;
    }


    const getResults = async () => {
        const res = await GetResults();
        if (!res || !res.data) { return }

        const genderFilter = 'm';
        const sortedResults = res.data.sort((a, b) => b.total_points - a.total_points);
        setResults(sortedResults)
        console.log(sortedResults)

        // const filtered = sortedResults.filter((result) => {
        //     const isGenderMatch = result.rider_gender.toLowerCase() === genderFilter;
        //     return isGenderMatch;
        // });

        setFilteredResults([...sortedResults])
    }

    const getUserLeagues = async () => {
        //get all leagues that a user is apart of. 
        const userData = await getUser()
        if (!userData) { return }
        const _user = userData.data

        if (!_user) { return }
        if (!'rampageLeagues' in _user) {
            console.log("NO RAMPAGE LEAGUES IN USER")
            return
        }

        if (!Array.isArray(_user.rampageLeagues)) {
            console.log("USER TEAMS is not an array")
            return
        }

        setUserTeams(_user.rampageLeagues)
        setUserTeam(_user.rampageTeam)

        // const leagueIds = _user.rampageLeagues.map((team) => team.leagueId)
        const response = await GetLeaguesByIds(_user.rampageLeagues)
        if (!response || !response.data) { return }
        setLeagues(response.data)
    }

    const JoinGlobalLeague = async () => {
        const userId = localStorage.getItem("userID")
        const res = await AddUserToLeague(userId, GLOBAL_LEAGUEID)

        if (res) {
            navigate(`/rampage/EditTeam?leagueId=${GLOBAL_LEAGUEID}`)
        }
    }

    const goToLeague = (id) => {
        navigate(`/rampage/League?leagueId=${id}`)
    }

    const editMyTeam = () => {
        navigate(`/rampage/EditTeam`)
    }


    const InfoIcon = () => {
        const renderTooltip = (props) => (
            <Tooltip id="button-tooltip" {...props}>
                To share private league with friends, send them the League URL below.
            </Tooltip>
        );

        return (
            <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
            >
                <Button className='mb-1 mx-0 px-1 py-0' variant="Link">
                    <FiInfo></FiInfo>
                </Button>
            </OverlayTrigger>)
    };


    const getNextEvent = async () => {
        const res = await GetNextEvent()
        if (!res) { return }
        setNextEvent(res.data)
    }


    //Get team from user
    const getTeam = async (id) => {
        const userId = localStorage.getItem("userID")
        const _teamData = await GetTeam(userId)

        if (!_teamData) { return }
        if (!'data' in _teamData) {
            console.log('No data in team')
            return
        }
        const _team = _teamData.data
        return _team
    }

    //Gets the list of all riders
    const getRiders = async () => {
        const riders = await GetRiders()

        if (!riders) { return }
        if (riders.data.length == 0) { return }

        const sorted = [...riders.data].sort((a, b) => b.value - a.value);
        const _countries = [...new Set(riders.data.map(obj => obj.country))].sort((a, b) => a.localeCompare(b));

        return sorted
    }

    const getRidersAndTeam = async () => {
        const _riders = await getRiders()

        const _team = await getTeam()

        if (!_team) { return }
        if (!'riders' in _team) { return }

        const _teamRiders = []

        //Match team rider Id's to riders array
        _team.riders.map((teamRider, index) => {
            const _rider = _riders.find(rider => rider._id == teamRider.riderId)
            _rider.position = teamRider.position
            const isInTeam = team.some((teamRider) => teamRider.riderId === _rider._id);

            if (_rider && !isInTeam) {
                _teamRiders.push(_rider)
            }
        })

        if (_teamRiders.length != 0) {
            setTeam(_teamRiders)
        }
    }

    // const getEvents = async () => {
    //     const _events = await GetEvents()
    //     console.log(_events)
    //     if (_events) {
    //         setEvents(_events.data)
    //     }
    // }

    const copyURL = async (url) => {
        navigator.clipboard.writeText(url)
            .then(() => {
                console.log('URL copied to clipboard', url);
            })
            .catch((error) => {
                console.error('Failed to copy URL:', error);
            });
    }

    const handleInstagramClick = () => {
        window.open('https://www.instagram.com/downhillmtbfantasy', '_blank');
    }

    const getTimeRemaining = () => {
        const now = new Date().getTime();
        const timeDifference = targetDate - now;

        if (timeDifference > 0) {
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            return { days, hours, minutes, seconds, timeDifference };
        }

        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    };


    const handleFilter = (genderValue, pointsFilter, eventId) => {
        setGenderFilter(genderValue)
        setPointsFilter(pointsFilter)

        const genderFilter = genderValue === 'Male' ? 'm' : 'f';
        const filtered = results.filter((result) => {
            const isGenderMatch = (genderValue === 'All' || result.rider_gender.toLowerCase() === genderFilter) && (result.eventId === eventId);
            return isGenderMatch;
        });

        let filteredAndSortedRiders = [...filtered]
        if (pointsFilter == 'Qualifying') {
            filteredAndSortedRiders.sort((a, b) => b?.qualifying_points - a?.qualifying_points);

        } else if (pointsFilter == 'Semis') {
            filteredAndSortedRiders.sort((a, b) => b?.semis_points - a?.semis_points);

        } else if (pointsFilter == 'Finals') {
            filteredAndSortedRiders.sort((a, b) => b?.finals_points - a?.finals_points);

        } else if (pointsFilter == 'Overall') {
            filteredAndSortedRiders.sort((a, b) => b?.total_points - a?.total_points);

        }

        console.log(filteredAndSortedRiders)
        setFilteredResults(filteredAndSortedRiders);
    }


    const handleOverallFilter = (genderValue) => {
        setOverallGenderFilter(genderValue)

        const overallGenderFilter = genderValue === 'Male' ? 'm' : 'f';

        const filtered = overallStandings.filter((result) => {
            const isGenderMatch = (genderValue === 'All' || result.rider_gender === overallGenderFilter)
            return isGenderMatch;
        });

        let filteredAndSortedRiders = [...filtered]
        filteredAndSortedRiders.sort((a, b) => b?.total_points - a?.total_points);

        setOverallFilteredResults(filteredAndSortedRiders);
    }


    const getEvents = async () => {
        const res = await GetEvents()

        if (!res || !res.data) { return }
        setEvents(res.data)
    }

    useEffect(() => {
        getUserLeagues()
        getNextEvent()
        getEvents()
        getResults()
        getEditingDisabled()
        getRidersAndTeam()
        // getOverallStandings()
    }, []);


    useEffect(() => {
        const timer = setInterval(() => {
            const newTimeRemaining = getTimeRemaining();
            setTimeRemaining(newTimeRemaining);

            if (newTimeRemaining.timeDifference <= 0) {
                if (!editingDisabled) {
                    DisableEditing();
                }
                clearInterval(timer);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [timeRemaining]);


    const displayTeam = (rider, index) => {
        const alpha2Code = getCountryISO2(rider.country);
        return (
            <div>
                <Card className="my-2 mx-3 border-0 shadow" style={{ backgroundColor: 'white' }}>
                    <Card.Body className="p-2">
                        <div className="row px-sm-4">
                            <div className="col-lg-1 col-2 d-flex flex-row align-items-center my-sm-0 my-2">{rider.position}</div>
                            <div className="col-sm-8 col-lg-9 col-10 flex-row align-items-center my-sm-0 my-2">
                                <Card.Title className="fs-6 my-0">
                                    <div className="d-flex flex-row">
                                        <Flag code={alpha2Code} style={{ maxHeight: '1rem' }} className="me-3 mb-0" />
                                        <span className="fw-light fs-6">{rider.first_name} </span>{rider.last_name}
                                    </div>
                                </Card.Title>
                            </div>
                            <div className="col-sm col fs-6 align-items-end-sm justify-content-end align-items-center fw-light mt-sm-0 mt-1 hidden-mobile">
                                <FaBirthdayCake className="me-1 mb-1"></FaBirthdayCake> {rider.DOB}
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }

    const renderResults = (result, index, type) => {
        return (
            <>
                {
                    result.eventId == event._id &&
                    <tr key={index}>
                        <td style={{ fontSize: '14px' }}>{index + 1}</td>
                        <td style={{ fontSize: '14px' }}>{result.rider_first_name} <b>{result.rider_last_name}</b></td>
                        {type == 'Overall' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.total_points}</td>}
                        {/* {type == 'Qualifying' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.qualifying_points}</td>}
                        {type == 'Semis' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.semis_points}</td>}
                        {type == 'Finals' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.finals_points}</td>} */}
                    </tr>
                }
            </>
        )
    }

    const renderOverallResults = (result, index) => {
        return (
            <>
                {
                    <tr key={index}>
                        <td style={{ fontSize: '14px' }}>{index + 1}</td>
                        <td style={{ fontSize: '14px' }}>{result.rider_first_name} <b>{result.rider_last_name}</b></td>
                        <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.total_points}</td>
                    </tr>
                }
            </>
        )
    }

    const renderEventCards = (_event, index) => {
        const country = "USA"
        const inPast = new Date() > new Date(_event?.date) ? true : false;
        const isNext = _event?.date == nextEvent?.date ? true : false;

        const backgroundColor = inPast ? '#fcffff' : '#ebebeb'
        return (
            <>

                {
                    !isNext ? <Card key={index} border='none' className="mx-2 my-2 shadow border-0" text={inPast ? 'dark' : 'secondary'} style={{ width: '370px', minWidth: '330px', backgroundColor: `${backgroundColor}` }}>
                        <Card.Body>
                            <Card.Title className="fs-6 pb-0 mb-0">
                                <div className="d-flex align-items-center justify-content-between" >
                                    <div className="">  {!inPast && <AiOutlineLock className="me-1 mb-1"></AiOutlineLock>}{_event?.discipline}</div>
                                    {inPast && <Button variant='secondary' style={{ fontSize: '14px' }} onClick={() => { setEvent(_event); setShowResults(true); handleFilter(genderFilter, pointsFilter, _event._id) }} className="py-0 fw-light"><FaFlagCheckered className="mb-1 me-1" /> View Results</Button>}
                                </div>
                            </Card.Title>
                            <Card.Text className="fw-light" style={{ fontSize: '14px' }}>
                                <div className="">{country}</div>
                                <div className="">Start date: {formatDate(_event?.date)} </div>
                            </Card.Text>

                        </Card.Body>
                    </Card>
                        :
                        <Card key={index} className="mx-2 my-2" text='dark' border='warning' style={{ width: '370px', minWidth: '330px' }}>
                            <Card.Body>
                                <Card.Title className="fs-6 fw-bolder pb-0 mb-1">
                                    <div className="d-flex align-items-center justify-content-between align-items-center" >
                                        <div className="d-flex align-items-center">{_event?.discipline}</div>
                                        <div className="rounded-pill px-3  py-1 d-flex align-items-center fw-light" style={{ backgroundColor: '#bd6425', color: 'white', fontSize: '12px' }}>
                                            <FaCircle className="me-1" />
                                            UPCOMING
                                        </div>
                                    </div>
                                </Card.Title>
                                <Card.Text className="fw-light" style={{ fontSize: '14px' }}>
                                    <div className="">{country}</div>
                                    <div className="">Start date: {formatDate(_event?.date)}</div>
                                </Card.Text>
                            </Card.Body>
                        </Card>}
            </>

        )
    }


    const renderLeagues = (league, index) => {

        let matchingTeam = {}
        if (user && 'teams' in user) {
            matchingTeam = user.teams.find((team) => team.leagueId === league._id);
        }
        const teamId = matchingTeam ? matchingTeam.teamId : null

        return (
            <div className="" key={index}>
                <Card className="mx-3 my-4 border-0 shadow">
                    <Card.Header as="h5" className="fs-6"><FaUsers className="mb-1 me-1" /> {league.name}</Card.Header>
                    <Card.Body>
                        {league && 'private' in league && league.private &&
                            <div className="my-2 mb-3">
                                <InfoIcon></InfoIcon>
                                <Form.Label className="mt-1 fw-bold" style={{ fontSize: '14px' }}> League Url:</Form.Label>
                                <div className="row">
                                    <div className="col-md"> <Form.Control type='text' className='fw-light' style={{ fontSize: '14px' }} disabled readOnly value={`${URL}/Login?leagueId=${league._id}&type=rampage`} ></Form.Control></div>
                                    <div className="col-md-2 py-2 py-sm-0">
                                        <Button variant="secondary" className='mt-md-0 w-100' style={{ fontSize: '14px' }} onClick={() => copyURL(`${URL}/Login?leagueId=${league._id}&type=rampage`)}><FiCopy></FiCopy> Copy URL</Button>
                                    </div>
                                </div>
                            </div>}
                        <div className="" style={{ fontSize: '15px' }}>{league.description}</div>
                        {/* <hr></hr> */}
                        <div className="row mt-3">
                            <div className="col-lg-6 ">
                                <div className="d-flex flex-row justify-content-start">
                                    <div className="">
                                        <div className="fw-light" style={{ fontSize: '14px' }}>Next Event: {formatDate(nextEvent.date)}</div>
                                        <div className="fw-light" style={{ fontSize: '14px' }}>Players in League: {league.teams.length}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row d-flex flex-row justify-content-end">
                                    <div className="col-md-3 col-12  p-0 d-flex align-items-center justify-content-center">
                                        <Button className='mt-2 mx-md-2 ms-2 w-100 text-light' variant="warning" style={{ fontSize: '14px' }} onClick={() => goToLeague(league._id)}><RxEnter size={20} className="mb-1 me-2"></RxEnter>View League</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }

    return (
        <>
            <div className="left-ad">
                <a href="https://www.dmrbikes.com">
                    <img src={Tower_Ad_Left} className='left-ad' alt="Left Ad" />
                </a>
            </div>

            <div className="container rampage-container-background  pb-5 py-3" style={{ minHeight: '100vh' }}>
                <Helmet>
                    <title>Dashboard - 2023 Rampage Fantasy</title>
                    <meta name="description" content="View your dashboard and manage your fantasy teams. Stay up to date with the latest downhill mountain biking results and rankings." />
                </Helmet>

                <div className={`d-flex webkit-scrollbar`} style={{ height: '120px', overflowX: 'scroll' }} >
                    {Array.isArray(events) && events.map(renderEventCards)}
                </div>

                <div className="d-flex flex-row justify-content-center mb-5 mt-5">
                    <Card className="countdown-card-rampage border-white" text='light' bg='dark' style={{ maxWidth: '400px', minWidth: '360px' }}>
                        <Card.Body>
                            <div className="text-center fs-5 fw-bolder mb-2">{nextEvent?.discipline}</div>
                            <div className="row">
                                <div className="col-3 fw-lighter text-center">Days</div>
                                <div className="col-3 fw-lighter text-center">Hours</div>
                                <div className="col-3 fw-lighter text-center">Minutes</div>
                                <div className="col-3 fw-lighter text-center">Seconds</div>
                            </div>
                            <div className="row">
                                <div className="col-3 text-center fw-bold">{timeRemaining.days}</div>
                                <div className="col-3 text-center fw-bold">{timeRemaining.hours}</div>
                                <div className="col-3 text-center fw-bold">{timeRemaining.minutes}</div>
                                <div className="col-3 text-center fw-bold">{timeRemaining.seconds}</div>
                            </div>
                        </Card.Body>
                        <div className="fw-light mb-0 d-flex justify-content-center">*Time until team editing is locked</div>
                        <div className="fw-lighter mb-3 d-flex justify-content-center"> (Elite Qualifying)</div>

                    </Card>
                </div>
                <div className="row d-flex flex-row justify-content-center mt-2 ms-2 ms-sm-5 mb-3 text-muted">
                    <div className="col-sm text-sm-end ps-4" style={{ fontSize: '14px' }}>Follow on Instagram for team update reminders:</div>
                    <div className="col-sm text-start">
                        <Button variant='link' className="pt-sm-0 ps-sm-0" style={{ fontSize: '14px' }} onClick={handleInstagramClick}>
                            <FiInstagram /> downhillmtbfantasy
                        </Button></div>
                </div>


                {userTeam && <>
                    <div className="line-with-title-container">
                        <hr></hr>
                        <div className="title-rampage">My Team</div>
                    </div>
                    <div className="py-2">
                        {(Array.isArray(team)) && team.map(displayTeam)}
                    </div>
                    <div className="d-flex align-items-center justify-content-center w-100 mb-5 mt-2">
                        <Button variant='warning' className="px-5" onClick={() => editMyTeam()} disabled={editingDisabled}> <FiEdit className="mb-1 me-2" />Edit Team</Button>
                    </div>
                </>
                }

                <div className="line-with-title-container mt-4">
                    <hr></hr>
                    <div className="title-rampage">My Leagues</div>
                </div>
                {leagues.length != 0 &&
                    <div className="pt-1">
                        {Array.isArray(leagues) && leagues.map(renderLeagues)}
                    </div>
                }
                {
                    leagues.length == 0 && user?.rampageLeagues != undefined && user?.rampageLeagues.length == 0 &&
                    <div className="mx-3 my-4 py-3 pb-4">
                        <Card className="border-0 shadow">
                            <Card.Header as="h5" className="py-3"> <BiWorld className="me-2 mb-1"></BiWorld>Red Bull Rampage Fantasy</Card.Header>
                            <Card.Body>
                                <Card.Title className="px-3 py-2">Ready to join the action?</Card.Title>
                                <Card.Text className="px-3">
                                    <div className="mb-2">Get engaged with Red Bull Rampage 2023. </div>
                                    <div className="">Join us to create and compete in public or private leagues. Play with friends and win awesome prizes. </div>
                                </Card.Text>
                                <Button variant="outline-warning" className="mx-3 my-2" onClick={JoinGlobalLeague}>Join Global League</Button>
                                <hr></hr>
                                <Card.Text className="px-3 py-2 fw-light">
                                    Alternatively, you can explore the "Leagues" tab to find other leagues and compete on a more local scale.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Modal size='lg' show={showResults} onHide={() => setShowResults(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Results for Event: {formatDate(event?.date)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>


                        <Tabs
                            defaultActiveKey="Overall"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                            onSelect={(e) => handleFilter(genderFilter, e, event._id)}
                        >
                            <Tab eventKey="Overall" title="Overall">
                                <Table responsive="sm" striped bordered hover className="px-5">
                                    <thead>
                                        <tr>
                                            <th>Place</th>
                                            <th>Name</th>
                                            <th>Points</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResults(result, index, 'Overall'))}
                                    </tbody>
                                </Table>
                            </Tab>
                        </Tabs>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowResults(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
            <div className="right-ad">
                <a href="https://www.dmrbikes.com">
                    <img src={Tower_Ad_Right} className="right-ad" alt="Right Ad" />
                </a>
            </div>
        </>
    );
}

export default RampageDashboard;